import momentJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { faUserEdit, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams } from "react-router-dom";
import { CheckLg, List } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { getStaffExtSettings } from "../store/api/SystemSettingsAPI";
import { addOrUpdateStaff, getStaff, getStaffAttachments, getStaffLastCode } from "../store/api/StaffApi";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import Loader from "react-loader-spinner";
import { useHistory } from "react-router-dom";
import { setErrorDialog, checkNationalCode } from "../../store/api/CommonFunctions";
import StaffAttachments from "../Components/Staff/StaffAttachments";


const AddEditPersonnel = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [birthDate, setBirthDate] = useState(null);
    const [staffInfo, setStaffInfo] = useState({});
    const [popUser, setPopUser] = useState({ show: false });
    const [selectedUser, setSelectedUser] = useState(null);
    const { register, handleSubmit, errors } = useForm();
    const title = (Number(id) > 0 ? "ویرایش " : "ثبت ") + "اطلاعات پرسنل ";
    const { staffExtSettings } =
        useSelector(state => {
            return {
                staffExtSettings: state.SystemSettingsReducer.staffExtSettings
            }
        });
    function submitData(data) {
        data.StaffTransportationPercentShare = 0;
        data.StaffTransportationFixAmountShare = 0;
        data.StaffInstallCostPercentShare = 0;
        data.StaffInstallCostFixAmountShare = 0;
        data.StaffRepairCostPercentShare = 0;
        data.StaffRepairCostFixAmountShare = 0;
        data.StaffUsedPartsCostPercentShare = 0;
        data.StaffUsedPartsCostFixAmountShare = 0;
        data.StaffExtraUsedPartsCostPercentShare = 0;
        data.StaffExtraUsedPartsCostFixAmountShare = 0;
        data.StaffExtraServicesCostPercentShare = 0;
        data.StaffExtraServicesCostFixAmountShare = 0;
        data.StaffMainCoAmountPaymentPercentShare = 0;
        data.StaffMainCoAmountPaymentFixAmountShare = 0;
        data.IsAgency = false;
        data.ID = id;
        data.BirthDate = birthDate;
        data.IsOfficePersonel = true;
        if (Array.isArray(data.IsActive)) {
            data.IsActive = data.IsActive.some(i => i === "on");
        }
        if (Array.isArray(data.IsBlackListed)) {
            data.IsBlackListed = data.IsBlackListed.some(i => i === "on");
        }
        if (Array.isArray(data.IsMiddleMan)) {
            data.IsBlackListed = data.IsMiddleMan.some(i => i === "on");
        }        
        data.HasStorage = false;

        data.IsSaleAgent = 0;
        const onSuccess = (res) => {
            if (Number(res.ID) > 0) {
                if (!(Number(id) > 0)) {
                    history.push(`/BaseInfo/AddEditPersonnel/${res.ID}`);
                }
                setErrorDialog(dispatch, "success", title);
                setStaffInfo(data);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, title);
            }
        }
        addOrUpdateStaff(data, onSuccess)
    }
    function showModalUser() {
        const onSelect = (data) => {
            if (staffInfo) {
                staffInfo.RelatedUserID = "";
                staffInfo.RelatedUserName = "";
            }
            setSelectedUser(data);
        }
        setPopUser({
            show: true,
            selectUserWithName: onSelect
        })
    }
    function onSelectTab(indx) {
        if (indx === 1) {
            dispatch(getStaffAttachments(id));
        }
    }
    useEffect(() => {
        setBirthDate(null);
        setStaffInfo({});
        setSelectedUser(null);
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        dispatch(getStaffExtSettings());
        if (!(Number(id) > 0)) {
            const onGet = (res) => {
                if (res.Code) {
                    setStaffInfo({ Code: res.Code });
                }
                else {
                    setStaffInfo("PENDING");
                }
            }
            getStaffLastCode(onGet);
        }
        else {
            const onGet = (res) => {
                if (res === "PENDING") {
                    setStaffInfo("PENDING");
                }
                else if (res.Data) {
                    setStaffInfo(res.Data);
                }
            }
            getStaff(id, onGet)
        }
    }, [id])

    return (
        <div className="container-fluid mt-1">
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={Number(id) > 0 ? faUserEdit : faUserPlus} size="lg" />&nbsp;
                    {title}
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                    <Tabs onSelect={index => onSelectTab(index)}>
                        <TabList>
                            <Tab>اطلاعات پرسنل</Tab>
                            <Tab disabled={!(Number(id) > 0)}>پیوست ها</Tab>
                        </TabList>
                        <TabPanel>
                            {staffInfo === "PENDING" ? <div style={{ width: "100%", textAlign: "center" }}>
                                <Loader type="BallTriangle" color="#bb1370" height={30} width={30} /></div>
                                :
                                <form onSubmit={handleSubmit(submitData)}>
                                    <Row className="rowBorder">
                                        <Col md={1} className="form-group">
                                            <label className="ellipsisLabel">کد پرسنل: <span style={{ color: "red" }}>*</span></label>
                                            <Form.Control name="Code" ref={register({ required: true })} defaultValue={staffInfo?.Code ?? ""} />
                                            {errors?.Code && <small className="errors">وارد کردن کد الزامی است</small>}
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>نام پرسنل: </label><span style={{ color: "red" }}>*</span>
                                            <Form.Control name="FirstName" ref={register({ required: true })} defaultValue={staffInfo?.FirstName ?? ""} />
                                            {errors?.FirstName && <small className="errors">وارد کردن نام الزامی است</small>}
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>نام خانوادگی پرسنل: </label><span style={{ color: "red" }}>*</span>
                                            <Form.Control name="LastName" ref={register({ required: true })} defaultValue={staffInfo?.LastName ?? ""} />
                                            {errors?.LastName && <small className="errors">وارد کردن نام خانوادگی الزامی است</small>}
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>کاربر مرتبط: </label>
                                            <input type="hidden" name="RelatedUserID" ref={register({})} readOnly value={selectedUser?.ID ?? staffInfo?.RelatedUserID ?? ""} />
                                            <Form.Control name="RelatedUserName" readOnly value={selectedUser?.Name ?? staffInfo?.RelatedUserName ?? ""} />
                                            <Button className="btn-input-tiny" style={{ top: "26px" }} onClick={showModalUser}><List size={20} /></Button>
                                        </Col>
                                        <Col md={1} className="form-group">
                                            <label className="ellipsisLabel">جنسیت/نوع: <span style={{ color: "red" }}>*</span></label>
                                            <select className="form-control" name="Type" ref={register({ required: true })} defaultValue={staffInfo?.Type ?? ""}>
                                                <option value="">انتخاب کنید</option>
                                                <option value="مرد">مرد</option>
                                                <option value="زن">زن</option>
                                                <option value="حقوقی">حقوقی</option>
                                            </select>
                                            {errors?.Type && <small className="errors">انتخاب جنسیت/نوع الزامی است</small>}
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>کد ملی: </label>
                                            <Form.Control name="StaffNationalCode" ref={register({ validate: checkNationalCode })} defaultValue={staffInfo?.StaffNationalCode ?? ""} />
                                            {errors?.StaffNationalCode && <small className="errors">کد ملی وارد شده معتبر نیست</small>}
                                        </Col>
                                        <Col className="form-group col-md-1">
                                            <label className="ellipsisLabel">تاریخ تولد: </label>
                                            <DatePicker isGregorian={false} timePicker={false} className="form-control" name="BirthDate" onChange={value => { setBirthDate(value.local("en").format("YYYY-MM-DD")); }}
                                                value={staffInfo?.BirthDate ? momentJalaali(staffInfo.BirthDate.substring(0, 10)) : birthDate ? momentJalaali(birthDate) : null} />
                                        </Col>
                                        <Col md={3} className="form-group">
                                            <label>متن پیامک تبریک تولد: </label>
                                            <Form.Control name="HappyBirthdaySMSBody" ref={register({})} defaultValue={staffInfo?.HappyBirthdaySMSBody ?? ""} />
                                        </Col>
                                        <Col md={3} className="form-group">
                                            <label>توضیحات: </label>
                                            <Form.Control as="textarea" name="StaffDescription" rows={1} ref={register({})} defaultValue={staffInfo?.StaffDescription} />
                                        </Col>
                                        <Col md={4} className="form-group" style={{ color: "blue" }}>
                                            <label>سایر:</label>
                                            <Row className="rowBorder mt-1" style={{ paddingTop: "10px", paddingBottom: "10px", borderColor: "gray" }} >
                                                <Col md={2} style={{ width: "max-content", paddingLeft: 2 }}>
                                                    <input type="checkbox" className="form-check-input" ref={register({})} name="IsBlackListed" defaultChecked={staffInfo?.IsBlackListed ?? false} style={{ marginLeft: "3px" }} />
                                                    لیست سیاه
                                                </Col>
                                                <Col md={2} style={{ width: "max-content", paddingLeft: 4, paddingRight: 4 }}>
                                                    <input type="checkbox" className="form-check-input" ref={register({})} name="IsActive" defaultChecked={staffInfo?.IsActive ?? true} style={{ marginLeft: "3px" }} />
                                                    فعال
                                                </Col>
                                                <Col md={2} style={{ width: "max-content", paddingLeft: 4, paddingRight: 4 }}>
                                                    <input type="checkbox" className="form-check-input" ref={register({})} name="IsMiddleMan" defaultChecked={staffInfo?.IsMiddleMan ?? false} style={{ marginLeft: "3px" }} />
                                                    معرف
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="rowBorder mt-3">
                                        <div className="rowTitle">
                                            اطلاعات تماس
                                        </div>
                                        <Col md={2} className="form-group">
                                            <label>تلفن: </label>
                                            <Form.Control name="Phone" ref={register({})} defaultValue={staffInfo?.Phone ?? ""} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>شماره همراه: </label>
                                            <Form.Control name="Mobile" ref={register({})} defaultValue={staffInfo?.Mobile ?? ""} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>پست الکترونیک: </label>
                                            <Form.Control name="Email" ref={register({})} defaultValue={staffInfo?.Email ?? ""} />
                                        </Col>
                                        <Col md={4} className="form-group">
                                            <label>نشانی: </label>
                                            <Form.Control name="Address" ref={register({})} defaultValue={staffInfo?.Address ?? ""} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>کد پستی: </label>
                                            <Form.Control name="PostalCode" ref={register({})} defaultValue={staffInfo?.PostalCode ?? ""} />
                                        </Col>
                                    </Row>
                                    <Row className="rowBorder mt-3">
                                        <div className="rowTitle">حسابداری</div>
                                        <Col md={2} className="form-group">
                                            <label>حساب بانکی: </label>
                                            <Form.Control name="BankAccountInfo" ref={register({})} defaultValue={staffInfo?.BankAccountInfo ?? ""} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>نحوه محاسبه پورسانت فروش: </label>
                                            <select className="form-control" name="SalePercentCalcMethod" ref={register({})} defaultValue={staffInfo?.SalePercentCalcMethod ?? ""}>
                                                <option value={false}>برحسب سود فاکتور</option>
                                                <option value={true}>برحسب کل فاکتور</option>
                                            </select>
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>پورسانت فروش: </label>
                                            <Form.Control type="number" name="SalePoorsant" ref={register({})} defaultValue={staffInfo?.SalePoorsant ?? 0} />
                                        </Col>

                                    </Row>
                                    <Row className="rowBorder mt-3">
                                        <div className="rowTitle">
                                            سایر اطلاعات
                                        </div>
                                        {staffExtSettings && Array.isArray(staffExtSettings) &&
                                            staffExtSettings.map((ext, i) =>
                                                <Col md={2} className="form-group" key={i}>
                                                    <label>{ext.SettingValue}</label>
                                                    <Form.Control name={`ExtraAttr${i + 1}`} ref={register({})} defaultValue={staffInfo ? staffInfo[`ExtraAttr${i + 1}`] : ""} />
                                                </Col>)
                                        }
                                    </Row>
                                    <Button type="submit" className="mt-1 group-Btn-large" variant="success"><CheckLg />&nbsp;ثبت اطلاعات</Button>
                                </form>
                            }
                        </TabPanel>
                        <TabPanel>
                            <StaffAttachments staffID={id} />
                        </TabPanel>
                    </Tabs>
                </Card.Body>
            </Card>
        </div>
    )

}
export default AddEditPersonnel;